import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { TenderRegistrationVM } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import { loadTenderRegistrationDataById } from '~src/services/api';

export const useTenderFolderRegistration = (
  {
    projectId,
    tender_id,
  }: Parameters<typeof loadTenderRegistrationDataById>[0],
  queryConfig: QueryConfig<TenderRegistrationVM, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<TenderRegistrationVM, AxiosError>(
    [
      QueryKeys.tenderRegistration,
      {
        projectId,
        tender_id,
      },
    ],
    (_, params) => loadTenderRegistrationDataById(params),
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
